/* Version: 3.5.137 */
'use client';
import 'react';
import PropTypes from 'prop-types';
import { StyledSpinner } from './styledComponents.js';
import { jsx } from 'react/jsx-runtime';
import useTheme from '../../hooks/useTheme.js';

var CircularIndeterminate = function CircularIndeterminate(_ref) {
  var color = _ref.color,
    _ref$magnitude = _ref.magnitude,
    magnitude = _ref$magnitude === undefined ? 4 : _ref$magnitude;
  var theme = useTheme();
  var ringColor = color || theme.colorPalette.primaryColors.main.shade_default;
  return /*#__PURE__*/jsx(StyledSpinner, {
    viewBox: "0 0 50 50",
    color: ringColor,
    magnitude: magnitude,
    title: "spinner",
    children: /*#__PURE__*/jsx("circle", {
      className: "path",
      cx: "25",
      cy: "25",
      r: "20",
      fill: "none",
      strokeWidth: "".concat(magnitude)
    })
  });
};
process.env.NODE_ENV !== "production" ? CircularIndeterminate.propTypes = {
  color: PropTypes.string,
  magnitude: PropTypes.number
} : undefined;
process.env.NODE_ENV !== "production" ? CircularIndeterminate.displayName = 'CircularIndeterminate' : undefined;

export { CircularIndeterminate as default };
